import { render, staticRenderFns } from "./fileView.vue?vue&type=template&id=707d221e"
import script from "./fileView.vue?vue&type=script&lang=js"
export * from "./fileView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports